var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ZoneVsColliderRule } from "./ZoneVsColliderRule";
/**
 * An example how to extend the ZoneVsColliderRule to ignore some items. Consider a shower where products are not allowed to be placed
 * in general, but in case the product being placed has an IAmActuallyAllowedToBeInAShowerComponent then the rule should not apply
 */
var ZoneVsColliderExceptSomeThingsRule = /** @class */ (function (_super) {
    __extends(ZoneVsColliderExceptSomeThingsRule, _super);
    function ZoneVsColliderExceptSomeThingsRule(componentIdToExclude, restrictedLayer, severity, includeAncestors) {
        var _this = _super.call(this, restrictedLayer, severity, includeAncestors) || this;
        _this.componentIdToExclude = componentIdToExclude;
        return _this;
    }
    ZoneVsColliderExceptSomeThingsRule.prototype.checkIntersectingZones = function (entity, other) {
        if (entity.hasComponent(this.componentIdToExclude) ||
            other.hasComponent(this.componentIdToExclude))
            return null;
        return _super.prototype.checkIntersectingZones.call(this, entity, other);
    };
    return ZoneVsColliderExceptSomeThingsRule;
}(ZoneVsColliderRule));
export { ZoneVsColliderExceptSomeThingsRule };
// end::snippet-custom-functional-zones-validation
//# sourceMappingURL=ZoneVsColliderExceptSomeThingsRule.js.map